///////// ORIGINAL MODEL FROM INSTRUMENT COMING FROM API//////////////////////
export interface InstrumentAPI {
  instrumentsId: string;
  instrumentsType: string;
  description: string;
  instrumentName: InstrumentNameAPI[];
  introduction: IntroductionAPI[];
  help: HelpAPI[];
  termsConditions: TermsConditionsAPI[];
  section: SectionAPI[];
  availableLanguages: string;
}
export class InstrumentNameAPI {
  languageCode: string | undefined;
  instrumentNameText: string | undefined;
}
export class IntroductionAPI {
  languageCode: string | undefined;
  introText: string | undefined;
  patientTerms: PatientTerm[] | undefined;
}
export class HelpAPI {
  languageCode: string | undefined;
  helpText: string | undefined;
  patientTerms: PatientTerm[] | undefined;
}
export class TermsConditionsAPI {
  languageCode: string | undefined;
  termsConditionText: string | undefined;
  patientTerms: PatientTerm[]|undefined;
}
export class SectionAPI {
  sectionName: string | undefined;
  sectionTitle: SectionTitleAPI[] | undefined;
  sectionDescription: SectionDescriptionAPI[] | undefined;
  sectionQuestionHeader: SectionQuestionHeaderAPI[] | undefined;
}
export class SectionTitleAPI {
  languageCode: string | undefined;
  sectionTitleText: string | undefined;
  patientTerms!: PatientTerm[];
}
export class SectionDescriptionAPI {
  languageCode: string | undefined;
  sectionDescriptionText: string | undefined;
  patientTerms!: PatientTerm[];
}
export class SectionQuestionHeaderAPI {
  languageCode: string | undefined;
  sectionQuestionHeaderText: string | undefined;
  patientTerms!: PatientTerm[];
}
//////////////////////////////////////////////////////////////////////

interface PatientTerm {
  patientTerm: string;
  text: string;
}

export interface Instrument {
  instrumentsId: string;
  instrumentsType: string;
  description: string;
  instrumentName: string;
  introductionText: string;
  helpText: string;
  termsConditionsText: string;
  section: Section[]
  availableLanguages: string;
  help: HelpAPI;
  introduction: IntroductionAPI;
  termsConditions: TermsConditionsAPI;
}

export class Section {
  sectionName: string | undefined;
  sectionTitleText: string | undefined;
  sectionDescriptionText: string | undefined;
  sectionQuestionHeaderText: string | undefined;
  sectionDescription!: SectionDescriptionAPI;
  sectionQuestionHeader!: SectionQuestionHeaderAPI;
  sectionTitle!: SectionTitleAPI;
}

interface LocalizedContent {
  languageCode: string
  text: string
  patientTerms: PatientTerm[]
}

interface QuestionnaireAnswer {
  answerId: string
  answerContent: LocalizedContent[]
  patientTerm: string
  scaleValue: string
  scoreAssignment: string
}

interface QuestionnaireQuestion {
  questionId: string
  responseType: string
  surveySection: string
  answerType: string
  answers: QuestionnaireAnswer[]
  
  questionContent: LocalizedContent[]
  dimension: string
  sequenceNumber: number
}

export interface Questionnaire {
  launchId: string
  instrumentsId: string
  organizationCode: string
  availableLanguageCodes: string
  questions: QuestionnaireQuestion[]
}